// Generated by Melange

import * as Caml_js_exceptions from "melange.js/caml_js_exceptions.jsx";
import * as Caml_option from "melange.js/caml_option.jsx";
import * as Curry from "melange.js/curry.jsx";
import * as Fx from "../../fx/fx.jsx";
import * as Js__Js_dict from "melange.js/js_dict.jsx";
import * as Json__Json_decode from "melange-json/Json_decode.jsx";
import * as Stdlib__Option from "melange/option.jsx";
import * as Subsonic__Failed from "./failed.jsx";

function buildSubsonicApiUrl(param, request) {
  const url = new URL(request._method, param.serverBaseUrl);
  const searchParams = url.searchParams;
  searchParams.set("c", "Violette");
  searchParams.set("f", "json");
  searchParams.set("s", param.salt);
  searchParams.set("t", param.token);
  searchParams.set("u", param.username);
  searchParams.set("v", "1.8.0");
  Js__Js_dict.entries(request.params).forEach(function (param) {
    const v = param[1];
    const k = param[0];
    if (v.TAG === /* Array */ 0) {
      v._0.forEach(function (v) {
        searchParams.append(k, v);
      });
      return;
    }
    searchParams.set(k, v._0);
  });
  return url;
}

function fetchWithUrlFx(url) {
  return {
    TAG: /* Async */ 3,
    _0: (function (param) {
      return fetch(url).then(function (response) {
        return Promise.resolve({
          TAG: /* Ok */ 0,
          _0: response
        });
      }).catch(function (param) {
        return Promise.resolve({
          TAG: /* Error */ 1,
          _0: /* NetworkError */ 1
        });
      });
    })
  };
}

function validateResponseJson(of_json, response) {
  return {
    TAG: /* Async */ 3,
    _0: (function (param) {
      return response.json().then(function (json) {
        let tmp;
        try {
          tmp = Json__Json_decode.oneOf({
            hd: (function (json) {
              return {
                TAG: /* Ok */ 0,
                _0: Curry._1(of_json, json)
              };
            }),
            tl: {
              hd: (function (json) {
                const match = Subsonic__Failed.of_json(json);
                const match$1 = match.response.error;
                return {
                  TAG: /* Error */ 1,
                  _0: {
                    TAG: /* ApiError */ 2,
                    code: match$1.code,
                    message: match$1.message
                  }
                };
              }),
              tl: /* [] */ 0
            }
          }, json);
        }
        catch (raw_issues){
          const issues = Caml_js_exceptions.internalToOCamlException(raw_issues);
          tmp = {
            TAG: /* Error */ 1,
            _0: {
              TAG: /* ValidationFailed */ 3,
              issues: issues
            }
          };
        }
        return Promise.resolve(tmp);
      });
    })
  };
}

function getContentType(response) {
  const partial_arg = ";";
  return Stdlib__Option.bind(Stdlib__Option.map((function (eta) {
    let param;
    return eta.split(partial_arg !== undefined ? Caml_option.valFromOption(partial_arg) : undefined, param !== undefined ? Caml_option.valFromOption(param) : undefined);
  }), Caml_option.null_to_opt(response.headers.get("content-type"))), (function (prim) {
    return Caml_option.undefined_to_opt(prim.shift());
  }));
}

function makeRequest(request, of_json) {
  return Fx.Monad_syntax.let$star(Fx.ask(undefined), (function (param) {
    const credentials = param.credentials;
    return Fx.Monad_syntax.let$star(credentials !== undefined ? fetchWithUrlFx(buildSubsonicApiUrl(credentials, request)) : ({
        TAG: /* Error */ 1,
        _0: /* NoCredentials */ 0
      }), (function (response) {
      return Fx.Monad_syntax.let$star(response.ok ? ({
          TAG: /* Ok */ 0,
          _0: response
        }) : ({
          TAG: /* Error */ 1,
          _0: {
            TAG: /* RequestFailed */ 0,
            status: response.status,
            statusText: response.statusText
          }
        }), (function (response) {
        const actual = getContentType(response);
        if (actual === "application/json") {
          return validateResponseJson(of_json, response);
        } else {
          return {
            TAG: /* Error */ 1,
            _0: {
              TAG: /* NonJsonContentType */ 1,
              actual: actual
            }
          };
        }
      }));
    }));
  }));
}

export {
  buildSubsonicApiUrl,
  fetchWithUrlFx,
  validateResponseJson,
  getContentType,
  makeRequest,
}
/* No side effect */
